import { defineComponent, watchEffect, computed, createElementBlock, createCommentVNode, openBlock } from "vue";
import { isFilled, asImageWidthSrcSet, asImagePixelDensitySrcSet } from "@prismicio/client";
import { DEV } from "esm-env";
import { devMsg } from "./lib/devMsg.js";
import { usePrismic } from "./usePrismic.js";
const _hoisted_1 = ["src", "srcset", "alt"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicImage" },
  __name: "PrismicImage",
  props: {
    field: {},
    imgixParams: {},
    alt: {},
    fallbackAlt: {},
    widths: {},
    pixelDensities: {}
  },
  setup(__props) {
    const props = __props;
    const { options } = usePrismic();
    if (DEV) {
      watchEffect(() => {
        if (typeof props.alt === "string" && props.alt !== "") {
          console.warn(
            `[PrismicImage] The "alt" prop can only be used to declare an image as decorative by passing an empty string (alt="") but was provided a non-empty string. You can resolve this warning by removing the "alt" prop or changing it to alt="". For more details, see ${devMsg(
              "alt-must-be-an-empty-string"
            )}`
          );
        }
        if (typeof props.fallbackAlt === "string" && props.fallbackAlt !== "") {
          console.warn(
            `[PrismicImage] The "fallbackAlt" prop can only be used to declare an image as decorative by passing an empty string (fallbackAlt="") but was provided a non-empty string. You can resolve this warning by removing the "fallbackAlt" prop or changing it to fallbackAlt="". For more details, see ${devMsg(
              "alt-must-be-an-empty-string"
            )}`
          );
        }
        if (props.widths && props.pixelDensities) {
          console.warn(
            `[PrismicImage] Only one of "widths" or "pixelDensities" props can be provided. You can resolve this warning by removing either the "widths" or "pixelDensities" prop. "widths" will be used in this case.`
          );
        }
      });
    }
    const image = computed(() => {
      var _a, _b;
      if (!isFilled.imageThumbnail(props.field)) {
        return;
      }
      let src;
      let srcSet;
      if (props.widths || !props.pixelDensities) {
        const res = asImageWidthSrcSet(props.field, {
          ...props.imgixParams,
          widths: props.widths === "defaults" ? (_a = options.components) == null ? void 0 : _a.imageWidthSrcSetDefaults : props.widths
        });
        src = res.src;
        srcSet = res.srcset;
      } else if (props.pixelDensities) {
        const res = asImagePixelDensitySrcSet(props.field, {
          ...props.imgixParams,
          pixelDensities: props.pixelDensities === "defaults" ? (_b = options.components) == null ? void 0 : _b.imagePixelDensitySrcSetDefaults : props.pixelDensities
        });
        src = res.src;
        srcSet = res.srcset;
      }
      return {
        src,
        srcSet,
        alt: props.alt ?? (props.field.alt || props.fallbackAlt)
      };
    });
    return (_ctx, _cache) => {
      return image.value ? (openBlock(), createElementBlock("img", {
        key: 0,
        src: image.value.src,
        srcset: image.value.srcSet,
        alt: image.value.alt
      }, null, 8, _hoisted_1)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicImage.vue.js.map
